(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elemental-hotspots"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elemental-hotspots')) {
  customElements.define('elemental-hotspots', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dots = Array.from(this.querySelectorAll('[data-hotspot]'));
      this.cards = Array.from(this.querySelectorAll('[data-hotspot-card]'));
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.show(index), options);
        dot.addEventListener('shopify:block:select', () => this.show(index, true), options);
        dot.addEventListener('shopify:block:deselect', () => this.close(), options);
      });
      this.querySelectorAll('[data-hotspot-close]').forEach(button => {
        button.addEventListener('click', () => this.close(true), options);
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.close(true);
      }, options);
    }
    close(restoreFocus = false) {
      const active = this.dots.find(dot => dot.getAttribute('aria-expanded') === 'true');
      this.dots.forEach(dot => {
        dot.classList.remove('is-active');
        dot.setAttribute('aria-expanded', 'false');
      });
      this.cards.forEach(card => card.hidden = true);
      if (restoreFocus && active) active.focus({ preventScroll: true });
    }
    show(index, force = false) {
      if (!this.cards[index]) return;
      const wasOpen = !this.cards[index].hidden;
      this.close();
      if (force || !wasOpen) {
        this.dots[index].classList.add('is-active');
        this.dots[index].setAttribute('aria-expanded', 'true');
        this.cards[index].hidden = false;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elemental-product-help"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-elemental-product-help]').forEach((root) => {
  const dialog = root.querySelector('[data-product-help-dialog]');
  const openButton = root.querySelector('[data-product-help-open]');
  const closeButton = root.querySelector('[data-product-help-close]');

  if (!dialog || !openButton || !closeButton) return;

  openButton.addEventListener('click', () => {
    if (typeof dialog.showModal === 'function') dialog.showModal();
  });

  closeButton.addEventListener('click', () => dialog.close());

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["freestyle_focus_library"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elemental-focus-library')) {
 customElements.define('elemental-focus-library',class extends HTMLElement {
 connectedCallback(){this.frame=requestAnimationFrame(()=>this.init());}
 disconnectedCallback(){cancelAnimationFrame(this.frame);this.querySelectorAll('video').forEach(video=>video.pause());this.controller?.abort();this.controller=null;}
 init(){if(this.controller||!this.isConnected)return;this.controller=new AbortController();const signal=this.controller.signal;
 this.cards=[...this.querySelectorAll('[data-card]')];this.known=new Set(this.cards.map(c=>c.dataset.key));this.ready=new Set(this.cards.filter(c=>c.dataset.ready==='true').map(c=>c.dataset.key));this.focus='all';this.state={saved:[],watched:[]};this.remember=this.querySelector('[data-remember]');this.equipment=this.querySelector('[data-equipment]');this.level=this.querySelector('[data-level]');this.position=this.querySelector('[data-position]');this.search=this.querySelector('[data-search]');this.savedOnly=this.querySelector('[data-saved-only]');this.legacyKeys=['elemental-pebble-mat-v1','elemental-freestyle-discovery-v1'];
 if(this.remember){try{const raw=JSON.parse(localStorage.getItem(this.dataset.storageKey)||'null');if(raw&&raw.version===2&&raw.remember===true){this.state.saved=this.clean(raw.saved,this.known);this.state.watched=this.clean(raw.watched,this.ready);this.remember.checked=true;}else if(!raw){this.importLegacy();}}catch{this.storageError=true;}}
 if(location.hash==='#pebble-mat')this.equipment.value='pebble';if(location.hash==='#reformer-movements')this.equipment.value='reformer';
 this.querySelectorAll('[data-enhanced]').forEach(e=>e.hidden=false);
 this.addEventListener('play',event=>{if(event.target instanceof HTMLVideoElement&&!event.target.classList.contains('elemental-quick-preview'))this.querySelectorAll('video').forEach(video=>{if(video!==event.target)video.pause();});},{capture:true,signal});
 this.addEventListener('click',e=>this.clicked(e),{signal});this.search.addEventListener('input',()=>this.render(),{signal});
 this.addEventListener('change',e=>{if(e.target===this.remember)this.persist();if(e.target===this.equipment&&this.equipment.value==='reformer')this.position.value='all';this.render();},{signal});
 document.addEventListener('shopify:block:select',e=>{if(this.contains(e.target)){this.clearFilters();this.render();}},{signal});this.render();}
 clean(value,allowed){return Array.isArray(value)?[...new Set(value.filter(v=>typeof v==='string'&&allowed.has(v)))]:[];}
 importLegacy(){for(const [index,key] of this.legacyKeys.entries()){let data;try{data=JSON.parse(localStorage.getItem(key)||'null');}catch{continue;}if(!data||data.remember!==true||data.version!==1)continue;this.remember.checked=true;const equipment=index===0?'pebble':'reformer';for(const card of this.cards.filter(c=>c.dataset.equipment===equipment)){if(Array.isArray(data.saved)&&data.saved.includes(card.dataset.legacyKey))this.state.saved.push(card.dataset.key);if(index===0&&Array.isArray(data.watched)&&data.watched.includes(card.dataset.legacyKey)&&this.ready.has(card.dataset.key))this.state.watched.push(card.dataset.key);}}this.state.saved=this.clean(this.state.saved,this.known);this.state.watched=this.clean(this.state.watched,this.ready);}
 persist(){if(!this.remember)return;try{if(this.remember.checked)localStorage.setItem(this.dataset.storageKey,JSON.stringify({version:2,remember:true,...this.state}));else{localStorage.removeItem(this.dataset.storageKey);for(const key of this.legacyKeys)localStorage.removeItem(key);}this.storageError=false;}catch{this.storageError=true;}}
 toggle(list,key){this.state[list]=this.state[list].includes(key)?this.state[list].filter(k=>k!==key):[...this.state[list],key];}
 clearFilters(){this.focus='all';this.equipment.value='all';this.level.value='all';this.position.value='all';this.search.value='';if(this.savedOnly)this.savedOnly.checked=false;}
 clicked(event){const button=event.target.closest('button');if(!button||!this.contains(button)||button.disabled)return;if(button.hasAttribute('data-focus-filter')){this.focus=button.dataset.focusFilter;}else if(button.hasAttribute('data-clear')){this.clearFilters();}else if(button.hasAttribute('data-reset-progress')){if(!window.confirm(this.dataset.confirm))return;this.state={saved:[],watched:[]};this.remember.checked=false;if(this.savedOnly)this.savedOnly.checked=false;this.persist();}else{const card=button.closest('[data-card]');if(!card)return;const key=card.dataset.key;if(button.hasAttribute('data-save-lesson'))this.toggle('saved',key);else if(button.hasAttribute('data-mark-watched')&&this.ready.has(key))this.toggle('watched',key);else return;this.persist();}this.render();this.querySelector('[data-status]').textContent=this.dataset.updated;}
 render(){const saved=new Set(this.state.saved),watched=new Set(this.state.watched),search=this.search.value.trim().toLowerCase(),equipment=this.equipment.value,level=this.level.value,position=this.position.value;this.position.disabled=equipment==='reformer';let visible=0;
 for(const card of this.cards){const d=card.dataset;card.hidden=(this.focus!=='all'&&!d.focus.split(',').includes(this.focus))||(equipment!=='all'&&d.equipment!==equipment)||(level!=='all'&&d.level!==level)||(position!=='all'&&d.position!==position)||(this.savedOnly?.checked&&!saved.has(d.key))||!d.title.toLowerCase().includes(search);if(card.hidden)card.querySelectorAll('video').forEach(video=>{if(!video.paused)video.pause();});if(!card.hidden)visible++;const save=card.querySelector('[data-save-lesson]'),watch=card.querySelector('[data-mark-watched]');if(save){save.setAttribute('aria-pressed',String(saved.has(d.key)));save.textContent=saved.has(d.key)?this.dataset.saved:this.dataset.save;}if(watch){watch.setAttribute('aria-pressed',String(watched.has(d.key)));watch.textContent=watched.has(d.key)?this.dataset.watched:this.dataset.mark;}}
 for(const group of this.querySelectorAll('[data-group]'))group.hidden=![...group.querySelectorAll('[data-card]')].some(c=>!c.hidden);for(const button of this.querySelectorAll('[data-focus-filter]'))button.setAttribute('aria-pressed',String(button.dataset.focusFilter===this.focus));this.querySelector('[data-count]').textContent=String(visible);this.querySelector('[data-empty]').hidden=visible>0;
 if(this.remember){this.querySelector('[data-watched-total]').textContent=String(watched.size);this.querySelector('[data-saved-total]').textContent=String(saved.size);this.querySelector('[data-progress]').value=watched.size;for(const milestone of this.querySelectorAll('[data-milestone]')){const earned=watched.size>=Number(milestone.dataset.milestone);milestone.classList.toggle('is-earned',earned);milestone.querySelector('[data-milestone-status]').textContent=earned?this.dataset.earned:this.dataset.notYet;}this.querySelector('[data-storage-message]').textContent=this.storageError?this.dataset.error:this.remember.checked?this.dataset.local:this.dataset.session;}}
 });
}

const initFreestyleMediaEnhancements=(root)=>{
 if(!(root instanceof Element)||root.dataset.mediaEnhanced==='true')return;
 root.dataset.mediaEnhanced='true';
 const playlist=root.querySelector('[data-playlist]');
 const list=root.querySelector('[data-playlist-list]');
 const empty=root.querySelector('[data-playlist-empty]');
 const count=root.querySelector('[data-playlist-count]');
 const dialog=root.querySelector('[data-fullscreen-dialog]');
 const stage=root.querySelector('[data-player-stage]');
 const title=root.querySelector('[data-player-title]');
 const featured=root.querySelector('[data-featured]');
 const featureStage=root.querySelector('[data-feature-stage]');
 const featureTitle=root.querySelector('[data-feature-title]');
 const featureEmpty=root.querySelector('[data-feature-empty]');
 const featureFullscreen=root.querySelector('[data-feature-fullscreen]');
 const topFiveList=root.querySelector('[data-topfive-list]');
 const topFiveEmpty=root.querySelector('[data-topfive-empty]');
 const topFiveCount=root.querySelector('[data-topfive-count]');
 let activeVideo=null,activeParent=null,activeNext=null,activeCard=null,featureCard=null;
 const cards=()=>[...root.querySelectorAll('[data-card]')];
 const readyCards=()=>cards().filter(card=>card.querySelector('video'));
 const savedCards=()=>cards().filter(card=>card.querySelector('[data-save-lesson]')?.getAttribute('aria-pressed')==='true');
 const showFeature=(card)=>{
  if(!featureStage||!featureTitle||!featureFullscreen)return;
  featureStage.querySelectorAll('video').forEach(video=>video.remove());
  const source=card?.querySelector('video');
  featureCard=source?card:null;
  featureFullscreen.disabled=!source;
  if(!source){featureTitle.textContent=root.dataset.featuredDefault||'Featured movement';if(featureEmpty)featureEmpty.hidden=false;return;}
  const clone=source.cloneNode(true);clone.removeAttribute('id');clone.controls=true;clone.autoplay=false;clone.muted=false;clone.preload='metadata';clone.classList.add('efocus__featured-video');
  if(featureEmpty)featureEmpty.hidden=true;featureStage.append(clone);featureTitle.textContent=card.dataset.title||root.dataset.featuredDefault||'Featured movement';
 };
 const renderFeatured=()=>{
  if(!featured||!topFiveList||!topFiveCount)return;
  const selected=savedCards().filter(card=>card.querySelector('video')).slice(0,5);
  topFiveList.innerHTML='';topFiveCount.textContent=selected.length+' / 5';
  if(topFiveEmpty)topFiveEmpty.hidden=selected.length>0;
  selected.forEach(card=>{const button=document.createElement('button');button.type='button';button.dataset.featureKey=card.dataset.key||'';button.textContent=card.dataset.title||'';button.setAttribute('aria-pressed',String(card===featureCard));topFiveList.append(button);});
  if(featureCard&&!selected.includes(featureCard)&&selected.length)showFeature(selected[0]);
  if(!featureCard){showFeature(selected[0]||readyCards()[0]||null);}
  topFiveList.querySelectorAll('[data-feature-key]').forEach(button=>button.setAttribute('aria-pressed',String(featureCard?.dataset.key===button.dataset.featureKey)));
 };
 const renderPlaylist=()=>{
  if(!playlist||!list||!count)return;
  const saved=savedCards();count.textContent=String(saved.length);list.innerHTML='';if(empty)empty.hidden=saved.length>0;
  saved.forEach(card=>{const row=document.createElement('div');row.className='efocus__playlist-item';const label=document.createElement('span');label.textContent=card.dataset.title||'';row.append(label);const play=document.createElement('button');play.type='button';play.textContent=root.dataset.playText||'Play';play.dataset.playKey=card.dataset.key||'';play.disabled=!card.querySelector('video');row.append(play);list.append(row);});
  renderFeatured();
 };
 const closePlayer=()=>{if(!dialog)return;if(activeVideo&&activeParent){activeVideo.pause();if(activeNext&&activeNext.parentNode===activeParent)activeParent.insertBefore(activeVideo,activeNext);else activeParent.append(activeVideo);}stage?.replaceChildren();activeVideo=activeParent=activeNext=activeCard=null;if(dialog.open)dialog.close();};
 const openCard=(card)=>{const video=card?.querySelector('video');if(!video||!dialog||!stage)return;if(dialog.open)closePlayer();activeVideo=video;activeParent=video.parentNode;activeNext=video.nextSibling;activeCard=card;title.textContent=card.dataset.title||'';stage.append(video);dialog.showModal();video.controls=true;video.play().catch(()=>{});};
 const movePlayer=(dir)=>{if(!activeCard)return;const ready=readyCards();const index=ready.indexOf(activeCard);if(index<0)return;const next=ready[(index+dir+ready.length)%ready.length];openCard(next);};
 root.addEventListener('click',event=>{
  const button=event.target.closest('button');if(!button||!root.contains(button))return;
  if(button.matches('[data-open-fullscreen]')){openCard(button.closest('[data-card]'));return;}
  if(button.dataset.quickKey){const card=root.querySelector('[data-card][data-key="'+CSS.escape(button.dataset.quickKey)+'"]');if(card)openCard(card);return;}
  if(button.matches('[data-quick-prev]')){root.querySelector('[data-quick-track]')?.scrollBy({left:-320,behavior:'smooth'});return;}
  if(button.matches('[data-quick-next]')){root.querySelector('[data-quick-track]')?.scrollBy({left:320,behavior:'smooth'});return;}
  if(button.matches('[data-feature-fullscreen]')){if(featureCard)openCard(featureCard);return;}
  if(button.matches('[data-close-fullscreen]')){closePlayer();return;}
  if(button.matches('[data-player-prev]')){movePlayer(-1);return;}
  if(button.matches('[data-player-next]')){movePlayer(1);return;}
  if(button.dataset.playKey){openCard(root.querySelector('[data-card][data-key="'+CSS.escape(button.dataset.playKey)+'"]'));return;}
  if(button.dataset.featureKey){const card=root.querySelector('[data-card][data-key="'+CSS.escape(button.dataset.featureKey)+'"]');showFeature(card);renderFeatured();return;}
  if(button.matches('[data-save-lesson]'))queueMicrotask(renderPlaylist);
 });
 dialog?.addEventListener('cancel',event=>{event.preventDefault();closePlayer();});
 dialog?.addEventListener('click',event=>{if(event.target===dialog)closePlayer();});
 const observer=new MutationObserver(renderPlaylist);cards().forEach(card=>{const save=card.querySelector('[data-save-lesson]');if(save)observer.observe(save,{attributes:true,attributeFilter:['aria-pressed']});});
 renderPlaylist();
};
const initAllFreestyleMedia=()=>document.querySelectorAll('elemental-focus-library').forEach(initFreestyleMediaEnhancements);
initAllFreestyleMedia();
document.addEventListener('shopify:section:load',initAllFreestyleMedia);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["freestyle_library"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elemental-movement-library')){customElements.define('elemental-movement-library',class extends HTMLElement{connectedCallback(){requestAnimationFrame(()=>this.init())}disconnectedCallback(){this.abort?.abort();this.ready=false}init(){if(this.ready||!this.isConnected)return;this.ready=true;this.abort=new AbortController();const signal=this.abort.signal;const cards=Array.from(this.querySelectorAll('[data-movement]'));const known=new Set(cards.map(c=>c.dataset.movement));const key=this.dataset.storageKey;const remember=this.querySelector('[data-remember]');const message=this.querySelector('[data-storage-message]');const passport=this.querySelector('[data-passport]');const announcement=this.querySelector('[data-announcement]');let explored=new Set(),saved=new Set(),filter='all',storageError=false;if(remember){try{const data=JSON.parse(localStorage.getItem(key)||'null');if(data&&data.version===1&&data.remember===true){remember.checked=true;for(const[field,target]of[['explored',explored],['saved',saved]]){if(Array.isArray(data[field]))data[field].filter(id=>typeof id==='string'&&known.has(id)).forEach(id=>target.add(id))}}}catch{storageError=true}}const write=()=>{if(!remember)return;try{if(remember.checked)localStorage.setItem(key,JSON.stringify({version:1,remember:true,explored:[...explored],saved:[...saved]}));else localStorage.removeItem(key);storageError=false}catch{storageError=true}};const render=()=>{const search=(this.querySelector('[data-search]')?.value||'').trim().toLowerCase();const onlySaved=this.querySelector('[data-only-saved]')?.checked||false;let visible=0;for(const card of cards){const id=card.dataset.movement;card.hidden=(filter!=='all'&&card.dataset.level!==filter)||!card.dataset.title.toLowerCase().includes(search)||(onlySaved&&!saved.has(id));if(!card.hidden)visible++;card.classList.toggle('is-explored',explored.has(id));for(const button of card.querySelectorAll('[data-action]')){const active=button.dataset.action==='explore'?explored.has(id):saved.has(id);button.setAttribute('aria-pressed',String(active));button.textContent=active?button.dataset.on:button.dataset.off}}for(const group of this.querySelectorAll('[data-group]'))group.hidden=!Array.from(group.querySelectorAll('[data-movement]')).some(c=>!c.hidden);this.querySelector('[data-empty]').hidden=visible!==0;this.querySelector('[data-visible-count]').textContent=String(visible);if(passport){this.querySelector('[data-total]').textContent=String(explored.size);this.querySelector('[data-overall]').value=explored.size;for(const seal of this.querySelectorAll('[data-seal]')){const members=cards.filter(c=>c.dataset.level===seal.dataset.seal);const count=members.filter(c=>explored.has(c.dataset.movement)).length;seal.classList.toggle('is-earned',members.length>0&&count===members.length);seal.querySelector('[data-seal-count]').textContent=count+' / '+members.length}}if(message)message.textContent=storageError?message.dataset.error:remember.checked?message.dataset.local:message.dataset.session};this.querySelectorAll('[data-enhanced],[data-passport]').forEach(el=>el.hidden=false);this.addEventListener('click',e=>{const button=e.target.closest('button');if(!button||!this.contains(button))return;if(button.dataset.filter){filter=button.dataset.filter;this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}else if(button.dataset.action){const id=button.closest('[data-movement]').dataset.movement;const target=button.dataset.action==='explore'?explored:saved;if(target.has(id))target.delete(id);else target.add(id);write();if(announcement)announcement.textContent=announcement.dataset.text}else if(button.hasAttribute('data-reset')){if(!window.confirm(button.dataset.confirm))return;explored.clear();saved.clear();remember.checked=false;write()}else return;render()},{signal});this.querySelector('[data-search]').addEventListener('input',render,{signal});this.querySelector('[data-only-saved]')?.addEventListener('change',render,{signal});remember?.addEventListener('change',()=>{write();render()},{signal});this.querySelectorAll('.efl__element').forEach(link=>link.addEventListener('click',()=>{filter='all';this.querySelector('[data-search]').value='';const only=this.querySelector('[data-only-saved]');if(only)only.checked=false;this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter==='all')));render()},{signal}));render()}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pebble_mat_library"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('elemental-pebble-library')) {
 customElements.define('elemental-pebble-library', class extends HTMLElement {
  connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
  initialize() {
   if (!this.isConnected || this.controller) return;
   this.controller = new AbortController();
   this.cards = Array.from(this.querySelectorAll('[data-epm-card]'));
   this.keys = new Set(this.cards.map(card => card.dataset.key));
   this.readyKeys = new Set(this.cards.filter(card => card.dataset.ready === 'true').map(card => card.dataset.key));
   this.state = {watched: [], saved: []};
   this.remember = this.querySelector('[data-remember]');
   if (!this.remember) return;
   try {
    const stored = JSON.parse(localStorage.getItem(this.dataset.storageKey) || 'null');
    if (stored && stored.version === 1 && stored.remember === true) {
     this.state.watched = this.clean(stored.watched, this.readyKeys);
     this.state.saved = this.clean(stored.saved, this.keys);
     this.remember.checked = true;
    }
   } catch {}
   this.querySelectorAll('[data-enhanced]').forEach(item => { item.hidden = false; });
   this.addEventListener('click', event => this.clicked(event), {signal: this.controller.signal});
   this.addEventListener('change', event => {
    if (event.target.matches('[data-remember]')) this.persist();
    this.render();
   }, {signal: this.controller.signal});
   this.render();
  }
  disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.controller = null; }
  clean(value, allowed) { return Array.isArray(value) ? [...new Set(value.filter(key => typeof key === 'string' && allowed.has(key)))] : []; }
  toggle(list, key) { this.state[list] = this.state[list].includes(key) ? this.state[list].filter(item => item !== key) : [...this.state[list], key]; }
  clicked(event) {
   const button = event.target.closest('button');
   if (!button || !this.contains(button) || button.disabled) return;
   const card = button.closest('[data-epm-card]');
   if (button.matches('[data-reset]')) {
    if (!window.confirm(this.dataset.resetConfirm)) return;
    this.state = {watched: [], saved: []};
    this.remember.checked = false;
    this.querySelector('[data-saved-only]').checked = false;
    this.persist();
    this.querySelector('[data-status]').textContent = this.dataset.resetDone;
   } else if (card && button.matches('[data-save-lesson]')) {
    this.toggle('saved', card.dataset.key);
    this.persist();
    this.querySelector('[data-status]').textContent = this.state.saved.includes(card.dataset.key) ? this.dataset.saved : this.dataset.unsaved;
   } else if (card && button.matches('[data-mark-watched]') && this.readyKeys.has(card.dataset.key)) {
    this.toggle('watched', card.dataset.key);
    this.persist();
    this.querySelector('[data-status]').textContent = this.state.watched.includes(card.dataset.key) ? this.dataset.watched : this.dataset.unwatched;
   }
   this.render();
  }
  persist() {
   this.storageError = false;
   try {
    if (this.remember.checked) localStorage.setItem(this.dataset.storageKey, JSON.stringify({version: 1, remember: true, ...this.state}));
    else localStorage.removeItem(this.dataset.storageKey);
   } catch { this.storageError = true; this.remember.checked = false; }
  }
  render() {
   const watched = new Set(this.state.watched);
   const saved = new Set(this.state.saved);
   const savedOnly = this.querySelector('[data-saved-only]').checked;
   this.cards.forEach(card => {
    const key = card.dataset.key;
    const saveButton = card.querySelector('[data-save-lesson]');
    const watchedButton = card.querySelector('[data-mark-watched]');
    saveButton.setAttribute('aria-pressed', String(saved.has(key)));
    saveButton.textContent = saved.has(key) ? this.dataset.saved : this.dataset.save;
    watchedButton.setAttribute('aria-pressed', String(watched.has(key)));
    watchedButton.textContent = watched.has(key) ? this.dataset.watched : this.dataset.mark;
    card.hidden = savedOnly && !saved.has(key);
   });
   this.querySelector('[data-watched-count]').textContent = String(watched.size);
   this.querySelector('[data-total-progress]').value = watched.size;
   this.querySelectorAll('[data-seal-group]').forEach(seal => {
    const cards = this.cards.filter(card => card.dataset.position === seal.dataset.sealGroup);
    const count = cards.filter(card => watched.has(card.dataset.key)).length;
    const earned = cards.length > 0 && count === cards.length;
    seal.dataset.earned = String(earned);
    seal.querySelector('[data-seal-count]').textContent = `${count} / ${cards.length}`;
    seal.querySelector('[data-seal-status]').textContent = earned ? this.dataset.seal : this.dataset.held;
   });
   this.querySelectorAll('[data-position-group]').forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-epm-card]')).some(card => !card.hidden); });
   this.querySelector('[data-empty]').hidden = this.cards.some(card => !card.hidden);
   this.querySelector('[data-storage-note]').textContent = this.storageError ? this.dataset.storageError : this.remember.checked ? this.dataset.remembered : this.dataset.local;
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
